export default __webpack_public_path__ + "static/media/new-close1.f0a8a642.svg";